import "./Footer.scss";
export const Footer = () => {
  return (
    <footer>
      <div className="footer">
        <p className="text">© Made by Onika Chorba</p>
      </div>
    </footer>
  );
};
